import React, { useState, useEffect } from 'react';

const API = 'https://khepri.tech/api/v1';

function Analytics() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(API + '/analytics')
      .then(r => r.json())
      .then(setData);
  }, []);

  if (!data) return <p style={{color:'#94A3B8'}}>Загрузка...</p>;

  const m = data.metrics;
  const funnel = data.funnel;
  const maxCount = Math.max(...funnel.map(f => f.count), 1);

  // Расчёт оценки бизнеса
  const monthlyRevenue = m.mrr || 0;
  const annualRevenue = monthlyRevenue * 12;
  const valuationLow = Math.round(annualRevenue * 3);
  const valuationMid = Math.round(annualRevenue * 5);
  const valuationHigh = Math.round(annualRevenue * 7);

  return (
    <div>
      <h2>Панель аналитики</h2>

      {/* Оценка бизнеса */}
      <div style={{ marginBottom: 20, padding: 16, background: '#1E293B', borderRadius: 12, border: '1px solid #334155' }}>
        <h3 style={{ marginBottom: 4 }}>💼 Оценка бизнеса (DCF)</h3>
        <p style={{ color: '#94A3B8', fontSize: 12, marginBottom: 12 }}>
          Оценочная рыночная стоимость на основе годовой выручки × мультипликатор
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10 }}>
          <div style={{ textAlign: 'center', padding: 10, background: '#0F172A', borderRadius: 8 }}>
            <div style={{ fontSize: 11, color: '#94A3B8', marginBottom: 4 }}>Консервативно (×3)</div>
            <div style={{ fontSize: 18, fontWeight: 700, color: '#F59E0B' }}>{valuationLow.toLocaleString()} ₽</div>
          </div>
          <div style={{ textAlign: 'center', padding: 10, background: '#0F172A', borderRadius: 8 }}>
            <div style={{ fontSize: 11, color: '#94A3B8', marginBottom: 4 }}>Базово (×5)</div>
            <div style={{ fontSize: 18, fontWeight: 700, color: '#10B981' }}>{valuationMid.toLocaleString()} ₽</div>
          </div>
          <div style={{ textAlign: 'center', padding: 10, background: '#0F172A', borderRadius: 8 }}>
            <div style={{ fontSize: 11, color: '#94A3B8', marginBottom: 4 }}>Оптимистично (×7)</div>
            <div style={{ fontSize: 18, fontWeight: 700, color: '#6366F1' }}>{valuationHigh.toLocaleString()} ₽</div>
          </div>
        </div>
        <p style={{ color: '#94A3B8', fontSize: 11, marginTop: 10 }}>
          На основе годовой выручки: {(annualRevenue || 0).toLocaleString()} ₽. Мультипликаторы: консервативно ×3, базово ×5, оптимистично ×7.
        </p>
      </div>

      {/* Ключевые метрики */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10, marginBottom: 20 }}>
        <div style={cardStyle}><div style={labelStyle}>CAC</div><div style={valueStyle}>{m.cac.toLocaleString()} ₽</div></div>
        <div style={cardStyle}><div style={labelStyle}>LTV</div><div style={valueStyle}>{m.ltv.toLocaleString()} ₽</div></div>
        <div style={cardStyle}><div style={labelStyle}>LTV/CAC</div><div style={valueStyle}>{m.ltv_cac_ratio}</div></div>
        <div style={cardStyle}><div style={labelStyle}>MRR</div><div style={valueStyle}>{m.mrr.toLocaleString()} ₽</div></div>
        <div style={cardStyle}><div style={labelStyle}>Прогноз ARR</div><div style={valueStyle}>{m.arr_forecast.toLocaleString()} ₽</div></div>
        <div style={cardStyle}><div style={labelStyle}>Отток</div><div style={valueStyle}>{m.churn_rate}</div></div>
      </div>

      {/* Воронка */}
      <h3 style={{ marginBottom: 12 }}>Воронка конверсии</h3>
      {funnel.map((f, i) => (
        <div key={i} style={{ marginBottom: 8 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 4 }}>
            <span>{f.stage}</span>
            <span style={{ color: '#94A3B8' }}>{f.count}</span>
          </div>
          <div style={{ background: '#334155', borderRadius: 4, height: 20, overflow: 'hidden' }}>
            <div style={{ width: (f.count / maxCount * 100) + '%', height: '100%', background: i === 0 ? '#6366F1' : i === 1 ? '#8B5CF6' : i === 2 ? '#10B981' : '#F59E0B', borderRadius: 4 }} />
          </div>
        </div>
      ))}
    </div>
  );
}

const cardStyle = { background: '#1E293B', padding: 14, borderRadius: 8, border: '1px solid #334155', textAlign: 'center' };
const labelStyle = { fontSize: 10, color: '#94A3B8', textTransform: 'uppercase', marginBottom: 4 };
const valueStyle = { fontSize: 16, fontWeight: 700 };

export default Analytics;